import React from 'react';
import PropTypes from 'prop-types';
import './styles/SlotInfo.scss';

const SlotInfo = ({ date, clubName, address }) => (
  <div className="slot-info">
    <div className="date">{date}</div>
    <div className="club-name">{clubName}</div>
    <div className="address">{address}</div>
  </div>
);

SlotInfo.propTypes = {
  date: PropTypes.string,
  clubName: PropTypes.string,
  address: PropTypes.string
};

SlotInfo.defaultProps = {
  date: '',
  clubName: '',
  address: ''
};

export default SlotInfo;



// WEBPACK FOOTER //
// ./src/components/SlotInfo.js